module.exports = __webpack_public_path__ + "55550135050d322edc2c008fa0327312.svg";